"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isNonNullObject=function(e){return null!==e&&"object"==typeof e};
//# sourceMappingURL=objects.js.map
